import {Component} from "@angular/core";

@Component({
	selector: 'cp-rotate-screen-detector',
	styleUrls: ['./rotate.screen.style.scss'],
	templateUrl: './rotate.screen.template.html'
})
export class RotateScreenComponent {

	constructor() {
	}
}
